var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_18367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9651 50.7992C39.9929 50.7992 51.3647 39.4274 51.3647 25.3996C51.3647 11.3717 39.9929 -7.62939e-05 25.9651 -7.62939e-05C11.9372 -7.62939e-05 0.56543 11.3717 0.56543 25.3996C0.56543 39.4274 11.9372 50.7992 25.9651 50.7992Z",
    fill: "#CA2115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.463 15.114H17.4673C14.1328 15.114 11.4297 17.8172 11.4297 21.1516V29.6478C11.4297 32.9823 14.1329 35.6854 17.4673 35.6854H34.463C37.7975 35.6854 40.5006 32.9822 40.5006 29.6478V21.1516C40.5006 17.8172 37.7974 15.114 34.463 15.114ZM30.3797 25.8131L22.4304 29.6043C22.2185 29.7055 21.9737 29.5512 21.9737 29.3165V21.4968C21.9737 21.2587 22.2249 21.1044 22.4371 21.212L30.3864 25.2404C30.6231 25.3601 30.6188 25.6992 30.3797 25.8131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_18367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7993,
    height: 50.7993,
    fill: "white",
    transform: "translate(0.564453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.89c548d2f0b602d23e4299eb98a4c615.svg";
export { ForwardRef as ReactComponent };